import Vue from 'vue'
import VueRouter from 'vue-router'

import config from '../config'

import auth from '../app/auth'
import UserInfoApi from '../app/user-info-api'
import UserInfoStore from '../app/user-info-store'

import Tester from '../views/Tester'
import Admin from '../views/Admin'

Vue.use(VueRouter)

function requireAuth (role, to, next, callback) {
  console.log(UserInfoStore.state.userRole)
  if (!auth.auth.isUserSignedIn()) {
    UserInfoStore.setLoggedIn(false)
    next({ path: '/' })
  } else {
    return UserInfoApi.getUserInfo().then(response => {
      UserInfoStore.setLoggedIn(true)
      UserInfoStore.setCognitoInfo(response)
      if (role != '*') {
        if (UserInfoStore.state.userRole != role) {
          next({ path: config.LOGIN_REDIRECT_URL })
        }
      }
      if (callback) {
        callback()
      } else {
        next()
      }
    })
  }
}

const routes = [
  {
    path: '/',
    beforeEnter (to, from, next) {
      auth.auth.getSession()
    }
  },
  {
    path: '/login/oauth2/code/cognito',
    beforeEnter (to, from, next) {
      var currUrl = window.location.href
      auth.auth.parseCognitoWebResponse(currUrl)
    }
  },
  {
    path: '/home',
    name: 'Home',
    beforeEnter (to, from, next) {
      requireAuth('*', to, next)
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    redirect: config.ADMIN_DEFAULT_PATH,
    beforeEnter (to, from, next) {
      requireAuth('admin', to, next)
    },
    children: [
      {
        path: '/admin/tester',
        name: 'AdminTester',
        component: _ => import('../views/AdminTester.vue'),
        beforeEnter (to, from, next) {
          requireAuth('admin', to, next)
        }
      },
      {
        path: '/admin/tester-stats',
        name: 'AdminTesterStats',
        component: _ => import('../views/AdminTesterStats.vue'),
        beforeEnter (to, from, next) {
          requireAuth('admin', to, next)
        }
      },
      {
        path: '/admin/report',
        name: 'AdminReport',
        component: _ => import('../views/AdminReport.vue'),
        beforeEnter (to, from, next) {
          requireAuth('admin', to, next)
        }
      },
      {
        path: '/admin/test',
        name: 'AdminTest',
        component: _ => import('../views/AdminTest.vue'),
        beforeEnter (to, from, next) {
          requireAuth('admin', to, next)
        }
      }
    ]
  },
  {
    path: '/tester',
    name: 'Tester',
    component: Tester,
    redirect: config.TESTER_DEFAULT_PATH,
    beforeEnter (to, from, next) {
      requireAuth('tester', to, next)
    },
    children: [
      {
        path: '/tester/home',
        name: 'TesterHome',
        component: _ => import('../views/TesterHome.vue'),
        beforeEnter (to, from, next) {
          requireAuth('tester', to, next)
        }
      },
      {
        path: '/tester/do/:testid',
        name: 'DoTest',
        component: _ => import('../views/DoTest/DoTest.vue'),
        beforeEnter (to, from, next) {
          requireAuth('tester', to, next)
        }
      }
    ]
  },
  {
    path: '/logout',
    redirect: '/'
  }

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
